




import React from "react";
import img1 from '../../images/industry/Construction_result.webp'
import img2 from '../../images/industry/Beauty & Lifestyle_result.webp'
import img3 from '../../images/industry/Education_result.webp'
import img4 from '../../images/industry/Finance_result.webp'
import img5 from '../../images/industry/Insurance_result.webp'
import img6 from '../../images/industry/Legal Consultancy_result.webp'
import img7 from '../../images/industry/Logistic_result.webp'
import img8 from '../../images/industry/Manufacturing_result.webp'
import img9 from '../../images/industry/Marketplace_result.webp'
import img10 from '../../images/industry/Retail_result.webp'
import img11 from '../../images/industry/Sports_result.webp'
import img12 from '../../images/industry/Travel_result.webp'
import img13 from '../../images/industry/healthcare_result.webp'
import img14 from '../../images/industry/on-demand_result[1].webp'

const WhyChooseUs = ({ slug }) => {
    
  // Content and image mapping based on slug
  const contentMap = {
    "healthcare": {
      title: "Why is RashTech Info the best choice for Healthcare Solutions?",
      content: "With our expertise in SEO Services, your healthcare platform can also gain better online visibility and reach more patients.",
      image: img13,
      listItems: [
        "Proven history of building customized healthcare software for hospitals, clinics, and telemedicine providers.",
        "Scalable adaptable solutions for small healthcare practices to big hospital groups.",
        "Top focus on data security, privacy, and compliance.",
        "Affordable solutions with quality deliverables in the shape of bespoke client solutions.",
        "Round-the-clock support, maintenance, and periodic system updates."
      ]
    },
    "finance": {
      title: "Why Choose RashTech Info for Finance Solutions?",
      content: "",
      image: img4,
      listItems: [
        "Expertise in creating bespoke FinTech software for banks, NBFCs, and startups.",
        "Secure platforms capable of handling high transaction volumes.",
        "Compliance-based solutions as per RBI, SEBI, and international financial standards.",
        "Scalable technology for small enterprises, large companies, and global markets.",
        "24/7 assistance and timely updates to ensure smooth operations.",
        "With our <a href='/seo-services'>SEO Services</a>, your financial platform can gain stronger online visibility, attracting more customers digitally."
      ]
    },
    "education": {
      title: "Why RashTech Info for Education Solutions?",
      content: "",
      image: img3,
      listItems: [
        "Proven track record of developing EdTech platforms for schools, colleges, and universities.",
        "Scalable and flexible software adaptable to both small institutes and global campuses.",
        "Strong focus on security, compliance, and student data privacy.",
        "Affordable, quality-driven solutions tailored for the education sector.",
        "Dedicated support, upgrades, and technical assistance.",
        "With our professional <a href='/seo-services'>SEO Services</a>, educational institutions can boost their digital presence and reach more students online."
      ]
    },
    "insurance": {
      title: "Why Use RashTech Info for Insurance Solutions?",
      content: "",
      image: img5,
      listItems: [
        "Extensive experience in developing custom software for brokers, agencies, and major insurance providers.",
        "Secure, compliant systems for handling sensitive customer and financial data.",
        "Scalable and cost-effective platforms for startups as well as large insurers.",
        "Mobile-first approach to improve customer accessibility and engagement.",
        "End-to-end support, maintenance, and continuous feature updates.",
        "With our digital <a href='/seo-services'>SEO Services</a>, insurers can expand their online visibility and attract more policyholders."
      ]
    },
    "legal-consultancy": {
      title: "Why RashTech Info for Legal & Consultancy?",
      content: "",
      image: img6,
      listItems: [
        "Proven record of delivering custom software for advisory firms, consultants, and law practices.",
        "Ability to design scalable, secure, and compliant solutions aligned with international standards.",
        "Affordable yet high-quality development for small firms as well as large enterprises.",
        "End-to-end service — from software development to integration, training, and support.",
        "Absolute focus on client confidentiality and trust.",
        "With our advanced <a href='/seo-services'>SEO Services</a>, legal firms can enhance their online visibility and attract more clients."
      ]
    },
    "logistics": {
      title: "Why RashTech Info for Logistics Solutions?",
      content: "",
      image: img7,
      listItems: [
        "Strong history of developing logistics software for transportation, warehousing, and supply chain companies.",
        "Technology platforms that adapt and scale with business growth.",
        "Real-time reporting and analytics for informed decision-making.",
        "High focus on automation to cut costs and minimize human error.",
        "24/7 support and regular system upgrades.",
        "With our result-driven <a href='/seo-services'>SEO services</a>, logistics companies can expand their online visibility and attract more partners and clients."
      ]
    },
    "construction": {
      title: "Why RashTech Info for Construction Solutions?",
      content: "",
      image: img1,
      listItems: [
        "Established expertise in crafting IT solutions for builders, contractors, and real estate companies.",
        "Scalable infrastructure compatible with projects of all sizes.",
        "Robust emphasis on compliance, data protection, and safety.",
        "Affordable technology with international standards.",
        "End-to-end support — development to integration and maintenance.",
        "With professional <a href='/seo-services'>SEO services</a> from us, building companies can increase their online visibility and acquire more customers."
      ]
    },
    "manufacturing": {
      title: "Why RashTech Info for Manufacturing Solutions?",
      content: "",
      image: img8,
      listItems: [
        "Specialists in developing IT solutions for factories, plants, and industrial businesses.",
        "Scalable solutions for small producers to international corporations.",
        "Robust emphasis on automation, compliance, and security.",
        "Affordable development with global quality standards.",
        "24x7 support, maintenance, and integration with legacy systems.",
        "Through our goal-driven <a href='/seo-services'>SEO services</a>, manufacturing businesses can enhance online presence and make global partners."
      ]
    },
    "marketplace": {
      title: "Why RashTech Info for Marketplace Solutions?",
      content: "",
      image: img9,
      listItems: [
        "Solid experience in creating e-commerce and marketplace platforms.",
        "Highly scalable systems created for startups, SMEs, and large businesses.",
        "Secure platforms to process payments, data, and large volumes of transactions.",
        "Affordable development to international standards.",
        "Complete service from design to development and support.",
        "Through our expert <a href='/seo-services'>SEO services</a>, marketplaces can drive digital visibility and get more buyers and sellers."
      ]
    },
    "on-demand": {
      title: "Why RashTech Info for On-Demand Solutions?",
      content: "",
      image: img14,
      listItems: [
        "Specialization in creating apps for food delivery, ride-sharing, healthcare, and lifestyle services.",
        "Scalable platforms designed for startups and enterprise-level companies.",
        "Emphasis on real-time update, customer experience, and secure transactions.",
        "Reliable, globally compliant, and cost-effective development.",
        "Ongoing support, updates, and third-party service integration.",
        "Through our advanced <a href='/seo-services'>SEO services</a>, on-demand businesses are capable of increasing online visibility and gathering more customers."
      ]
    },
    "retail": {
      title: "Why RashTech Info for Retail Solutions",
      content: "",
      image: img10,
      listItems: [
        "Proven track record of creating retail and e-commerce solutions for businesses of all sizes.",
        "Secure and scalable online and offline retail platforms.",
        "Customer experience focus on mobile-first and personalization considerations.",
        "Cost-effective, high-value solutions meeting international standards.",
        "Technical support, maintenance, and integration of third-party tools 24/7.",
        "Retailers can increase online visibility and attract more customers with our advanced SEO services."
      ]
    },
    "sports": {
      title: "Why RashTech Info for Sports Solutions?",
      content: "",
      image: img11,
      listItems: [
        "Established experience in constructing IT solutions for sports academies, gyms, and professional leagues.",
        "Flexible platforms designed for local clubs to global organizations.",
        "Performance focus, engagement, and data-driven outcomes.",
        "Affordable development with international quality standards.",
        "Full-cycle services with continuous support and maintenance.",
        "With our expert <a href='/seo-services'>SEO services</a>, sports brands and clubs can reach more online audiences."
      ]
    },
    "travel": {
      title: "Why RashTech Info for Travel Solutions?",
      content: "",
      image:img12,
      listItems: [
        "Decades of experience in developing IT solutions for travel agencies, OTAs, and hospitality suppliers.",
        "Scaleable platforms perfect for startups, SMEs, and global travel businesses.",
        "Security, real-time updates, and usability in focus.",
        "Cost-efficient technology with high-quality standards.",
        "End-to-end offerings like development, integration, and support.",
        "By our professional <a href='/seo-services'>SEO services</a>, travel companies can boost online visibility and engage more customers across the world."
      ]
    },
    "beauty-lifestyle": {
      title: "Why RashTech Info for Beauty & Lifestyle Solutions?",
      content: "",
      image: img2,
      listItems: [
        "Huge experience in creating IT solutions for salons, spas, fashion, and lifestyle brands.",
        "Scalable and mobile-first solutions for small business to large enterprise brands.",
        "High emphasis on customer engagement and personalization.",
        "Low-cost, secure, and high-quality platforms with international standards.",
        "End-to-end support, upgrades, and digital integrations.",
        "With our cutting-edge <a href='/seo-services'>SEO services</a>, lifestyle brands can expand their online presence and draw more customers."
      ]
    }
  };

  // Get content for current slug or return null if not found
  const content = contentMap[slug];
  
  if (!content) return null;

  return (
    <section className="why_choose_us_section section_space">
      <div className="container">
        <div className="row why_choose_us_row">
          {/* Image Column - Will appear first on tablet devices */}
          <div className="col-lg-6 col-md-12 col-sm-12 order-md-1 order-lg-0">
            <div className="image_container">
              <img 
                src={content.image} 
                alt={content.title} 
                className="why_choose_us_image" 
              />
            </div>
          </div>
          
          {/* Content Column - Will appear second on tablet devices */}
          <div className="col-lg-6 col-md-12 col-sm-12 order-md-2 order-lg-1">
            <div className="content_container">
              <h2 className="section_title">{content.title}</h2>
              {content.content && <p className="content_text">{content.content}</p>}
              
              {content.content2 && <p className="content_text">{content.content2}</p>}
              
              {content.subtitle && <h4 className="subtitle">{content.subtitle}</h4>}
              
              {content.listItems && (
                <ul className="feature_list">
                  {content.listItems.map((item, index) => (
                 
                     
                      <li key={index} className="feature_item" dangerouslySetInnerHTML={{ __html: item }} />
                    
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .why_choose_us_section {
          padding: 60px 0;
         
        }
        
        .why_choose_us_row {
          align-items: center;
          min-height: 500px;
          
        }
        
        .image_container {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
        }
        
        .why_choose_us_image {
          width: 100%;
          height: auto;
          max-height: 450px;
          object-fit: cover;
          border-radius: 10px;
          box-shadow: 0 5px 15px rgba(0,0,0,0.1);
          
        }
        
        .content_container {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 30px 20px 30px 40px;
          
        }
        
        .section_title {
          font-size: 1.8rem;
          font-weight: 700;
          margin-bottom: 20px;
          color: #333;
          line-height: 1.3;
        }
        
        .content_text {
          font-size: 1rem;
          line-height: 1.7;
          color: #666;
          margin-bottom: 20px;
        }
        
        .feature_list {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        
        .feature_item {
          position: relative;
          padding: 10px 0 10px 32px;
          font-size: 0.95rem;
          line-height: 1.6;
          color: #555;
          border-bottom: 1px solid #f0f0f0;
        }
        
        .feature_item:before {
          content: "✓";
          position: absolute;
          left: 0;
          top: 10px;
          color: #007bff;
          font-weight: bold;
          font-size: 1.1rem;
        }
        
        .feature_item:last-child {
          border-bottom: none;
        }
        
        /* Large Desktop (1200px and above) */
        @media (min-width: 1200px) {
          .why_choose_us_row {
            min-height: 500px;
          }
          
          .section_title {
            font-size: 2rem;
          }
          
          .content_container {
            padding: 30px 20px 30px 50px;
          }
          
          .why_choose_us_image {
            max-height: 450px;
          }
        }
        
        /* Desktop (992px - 1199px) */
        @media (min-width: 992px) and (max-width: 1199px) {
          .why_choose_us_row {
            min-height: 450px;
          }
          
          .section_title {
            font-size: 1.7rem;
          }
          
          .why_choose_us_image {
            max-height: 400px;
          }
        }
        
        /* Tablet Landscape (768px - 991px) */
        @media (min-width: 768px) and (max-width: 991px) {
          .why_choose_us_section {
            padding: 50px 0;
          }
          
          .why_choose_us_row {
            min-height: auto;
            flex-direction: column;
          }
          
          .image_container {
            height: auto;
            padding: 0px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;
            
          }
          
          .content_container {
            padding: 20px 15px 20px 25px;
            text-align: left;
            justify-content: flex-start;
            
          }
          
          .section_title {
            font-size: 1.5rem;
            margin-bottom: 15px;
            text-align: center;
          }
          
          .content_text {
            font-size: 0.95rem;
            line-height: 1.6;
            margin-bottom: 15px;
            text-align: left;
          }
          
          .why_choose_us_image {
            max-height: 350px;
            width: 100%
          }
          
          .feature_item {
            padding: 8px 0 8px 28px;
            font-size: 0.9rem;
            text-align: left;
          }
          
          .feature_item:before {
            top: 8px;
            font-size: 1rem;
          }
        }
        
        
        
        /* Mobile Landscape (576px - 599px) */
        @media (min-width: 576px) and (max-width: 599px) {
          .why_choose_us_section {
            padding: 40px 0;
          }
          
          .why_choose_us_row {
            min-height: auto;
            flex-direction: column;
          }
          
          .image_container {
            height: 280px;
            padding: 10px;
            margin-bottom: 0;
          }
          
          .content_container {
            padding: 25px 15px;
            text-align: left;
          }
          
          .section_title {
            font-size: 1.4rem;
            margin-bottom: 15px;
            text-align: center;
          }
          
          .content_text {
            font-size: 0.95rem;
            text-align: left;
          }
          
          .why_choose_us_image {
            max-height: 280px;
            width: 100%;
          }
          
          .feature_item {
            padding: 8px 0 8px 28px;
            font-size: 0.9rem;
            text-align: left;
          }
        }
        
        /* Mobile Portrait (below 576px) */
        @media (max-width: 575px) {
          .why_choose_us_section {
            padding: 30px 0;
            
          }
          
          .why_choose_us_row {
            min-height: auto;
            flex-direction: column;
          }
          
          .image_container {
            height: 220px;
            padding: 0;
            margin-bottom: 0;
          }
          
          .content_container {
            padding: 20px 0px;  
            text-align: left;
            
          }
          
          .section_title {
            font-size: 1.3rem;
            margin-bottom: 15px;
            line-height: 1.4;
            text-align: center;
          }
          
          .content_text {
            font-size: 0.9rem;
            line-height: 1.6;
            text-align: left;
          }
          
          .why_choose_us_image {
            max-height: 220px;
            width: 100%;
          }
          
          .feature_item {
            padding: 7px 0 7px 25px;
            font-size: 0.85rem;
            text-align: left;
          }
          
          .feature_item:before {
            top: 7px;
            font-size: 1rem;
          }
        }
        
        /* Extra Small Devices (below 400px) */
        @media (max-width: 400px) {
          .image_container {
            height: 200px;
          }
          
          .section_title {
            font-size: 1.2rem;
          }
          
          .content_text {
            font-size: 0.85rem;
          }
          
          .why_choose_us_image {
            max-height: 200px;
            width: 100%;
          }
          
          .feature_item {
            font-size: 0.8rem;
            padding: 6px 0 6px 22px;
          }
        }
        
        /* Ultra Wide Screens (1800px and above) */
        @media (min-width: 1800px) {
          .why_choose_us_row {
            min-height: 550px;
          }
          
          .section_title {
            font-size: 2.2rem;
          }
          
          .content_text {
            font-size: 1.1rem;
          }
          
          .why_choose_us_image {
            max-height: 550px;
          }
          
          .feature_item {
            font-size: 1rem;
          }
        }
      `}</style>
    </section>
  );
};

export default WhyChooseUs;